import produce from 'immer';
import { useEffect, useState } from 'react';
export function createStore(initialState) {
    var subscriptions = new Set();
    var store = {
        state: initialState,
        set: function (updateState) {
            var newState = updateState instanceof Function ? produce(store.state, updateState) : updateState;
            store.state = newState;
            subscriptions.forEach(function (setState) { return setState(newState); });
        },
        subscribe: function (setState) {
            subscriptions.add(setState);
        },
        unsubscribe: function (setState) {
            subscriptions.delete(setState);
        },
        useStore: function () {
            var _a = useState(store.state), state = _a[0], setState = _a[1];
            useEffect(function () {
                store.subscribe(setState);
                return function () { return store.unsubscribe(setState); };
            }, []);
            return [state, store.set];
        },
        reset: function () {
            store.set(initialState);
        },
    };
    return store;
}
